import { TypeSellTy } from '../../../../app/erp/screens/Logistic/QuoteParent/SellAllStats/SellStatsBody/types'
interface SellStatsURLs {
    EmployeeId: string
    CategoryId: string
    ProductId: string
}

const useSellStatsUrls = () => {
    const sellStatsURLs: Record<TypeSellTy, SellStatsURLs> = {
        QuoteOrder: {
            EmployeeId: '/api/app/order/quote/getAllQuoteOrdersCompleteForStats',
            CategoryId: '/api/app/order/quote/getAllQuoteOrdersProductsForStats',
            ProductId: '/api/app/order/quote/getAllQuoteOrdersProductsForStats'
        },
        SellOrder: {
            EmployeeId: '/api/app/order/sell/sellOrder/getAllSellOrdersCompleteForStats',
            CategoryId: '/api/app/order/sell/sellOrder/getAllSellOrdersProductsForStats',
            ProductId: '/api/app/order/sell/sellOrder/getAllSellOrdersProductsForStats'
        },
        SellDeliveryNote: {
            EmployeeId: '/api/app/order/sell/sellDeliveryNote/getAllSellDeliveryNotesCompleteForStats',
            CategoryId: '/api/app/order/sell/sellDeliveryNote/getAllSellDeliveryNotesProductsForStats',
            ProductId: '/api/app/order/sell/sellDeliveryNote/getAllSellDeliveryNotesProductsForStats'
        },
        SellInvoice: {
            EmployeeId: '/api/app/order/sell/sellInvoice/getAllSellInvoicesCompleteForStats',
            CategoryId: '/api/app/order/sell/sellInvoice/getAllSellInvoicesProductsForStats',
            ProductId: '/api/app/order/sell/sellInvoice/getAllSellInvoicesProductsForStats'
        },
        SellTicket: {
            EmployeeId: '/api/app/order/tpv/sellTicket/getAllSellTicketsCompleteForStats',
            CategoryId: '/api/app/order/tpv/sellTicket/getAllSellTicketsProductsForStats',
            ProductId: '/api/app/order/tpv/sellTicket/getAllSellTicketsProductsForStats'
        },
    }
    return sellStatsURLs
}

export default useSellStatsUrls